export function loadCircleChart(myChart, data, fontSizes) {
  var color = ["#FFD305", "#01B3E3", "#B583DD"];
  myChart.setOption({
    color: color,
    title: {
      text: "资金组成",
      left: "center",
      top: "center",
      textStyle: {
        fontSize: fontSizes,
        color: "#fff",
        fontWeight: "normal"
      }
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c}万元 ({d}%)"
    },
    legend: {
      orient: "vertical",
      right: 20,
      top: 20,
      show: false
    },
    series: [
      {
        type: "pie",
        roseType: "radius",
        radius: ["50%", "88%"],
        data: data,
        label: {
          show: false
        }
      }
    ]
  });
}
